export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export function pad(n: number, size: number) {
  let num = n.toString();
  while (num.length < size) num = `0${num}`;
  return num;
}

export function displayTime(seconds: number) {
  const ss = seconds % 60;
  const minutes = Math.floor(seconds / 60);
  const mm = minutes % 60;
  const hours = Math.floor(minutes / 60);
  return `${hours}:${pad(mm, 2)}:${pad(ss, 2)}`;
}

